'use strict';

bbw.filter.contains = function() {
    return function (input, value) {
        if (angular.isArray(input)) {
            return input.indexOf(value) >= 0;
        }
        if (angular.isObject(input)) {
            return value in input;
        }
        return false;
    };
};